import { BauartklasseLabel, Bauweise, Dacheindeckung, Fertighaus } from '../../interfaces';

/**
 * Every Fertighaus / Dacheindeckung / Bauweise combination, so `Record<BauartklasseKey, …>` below
 * fails to compile if one is ever missed.
 */
export type BauartklasseKey = `${Fertighaus}-${Dacheindeckung}-${Bauweise}`;

/** Ported from the B2B calculator so both apps name the same class for the same answers. */
export const bauartklasseIdentifier: Record<BauartklasseKey, BauartklasseLabel> = {
  [`${Fertighaus.Nein}-${Dacheindeckung.HarteBedachung}-${Bauweise.Massiv}`]:
    BauartklasseLabel.BakI,
  [`${Fertighaus.Nein}-${Dacheindeckung.HarteBedachung}-${Bauweise.StahlHolzfachwerkFv}`]:
    BauartklasseLabel.BakII,
  [`${Fertighaus.Nein}-${Dacheindeckung.HarteBedachung}-${Bauweise.StahlHolzfachwerkBv}`]:
    BauartklasseLabel.BakIII,
  [`${Fertighaus.Nein}-${Dacheindeckung.HarteBedachung}-${Bauweise.Holz}`]:
    BauartklasseLabel.BakIII,
  [`${Fertighaus.Nein}-${Dacheindeckung.WeicheBedachung}-${Bauweise.Massiv}`]:
    BauartklasseLabel.BakIV,
  [`${Fertighaus.Nein}-${Dacheindeckung.WeicheBedachung}-${Bauweise.StahlHolzfachwerkFv}`]:
    BauartklasseLabel.BakIV,
  [`${Fertighaus.Nein}-${Dacheindeckung.WeicheBedachung}-${Bauweise.StahlHolzfachwerkBv}`]:
    BauartklasseLabel.BakV,
  [`${Fertighaus.Nein}-${Dacheindeckung.WeicheBedachung}-${Bauweise.Holz}`]: BauartklasseLabel.BakV,
  [`${Fertighaus.Ja}-${Dacheindeckung.HarteBedachung}-${Bauweise.Massiv}`]: BauartklasseLabel.FhgI,
  [`${Fertighaus.Ja}-${Dacheindeckung.HarteBedachung}-${Bauweise.StahlHolzfachwerkFv}`]:
    BauartklasseLabel.FhgII,
  [`${Fertighaus.Ja}-${Dacheindeckung.HarteBedachung}-${Bauweise.StahlHolzfachwerkBv}`]:
    BauartklasseLabel.FhgIII,
  [`${Fertighaus.Ja}-${Dacheindeckung.HarteBedachung}-${Bauweise.Holz}`]: BauartklasseLabel.FhgIII,
  [`${Fertighaus.Ja}-${Dacheindeckung.WeicheBedachung}-${Bauweise.Massiv}`]:
    BauartklasseLabel.FhgIV,
  [`${Fertighaus.Ja}-${Dacheindeckung.WeicheBedachung}-${Bauweise.StahlHolzfachwerkFv}`]:
    BauartklasseLabel.FhgIV,
  [`${Fertighaus.Ja}-${Dacheindeckung.WeicheBedachung}-${Bauweise.StahlHolzfachwerkBv}`]:
    BauartklasseLabel.FhgV,
  [`${Fertighaus.Ja}-${Dacheindeckung.WeicheBedachung}-${Bauweise.Holz}`]: BauartklasseLabel.FhgV,
};

export function findBauartklasse(
  fertighaus: Fertighaus | null,
  dacheindeckung: Dacheindeckung | null,
  bauweiseAussenwaende: Bauweise | null
): BauartklasseLabel | null {
  if (!fertighaus || !dacheindeckung || !bauweiseAussenwaende) return null;

  return bauartklasseIdentifier[`${fertighaus}-${dacheindeckung}-${bauweiseAussenwaende}`] ?? null;
}
